/**
 * Sale Timer - Adds a countdown timer that resets daily and rotates shipping messages
 */
function SaleTimer(containerSelector) {
    this.container = document.querySelector(containerSelector);
    if (!this.container) return;
    
    // Message switching variables
    this.message1 = this.container.querySelector('.shipping-message-1');
    this.message2 = this.container.querySelector('.shipping-message-2');
    
    // Only setup message switching if both messages exist and have content
    this.hasAlternateMessages = this.message1 && this.message2 && 
                               this.message1.textContent.trim() !== '' && 
                               this.message2.textContent.trim() !== '';
    
    // Create the timer wrapper element
    this.timerElement = document.createElement('span');
    this.timerElement.textContent = ' - Today’s Deals End in ';
    
    // Create the clock element
    this.clockElement = document.createElement('span');
    this.clockElement.classList.add('clock');
    
    this.initialize();
  }
  
  SaleTimer.prototype.initialize = function() {
    // Append the timer elements only to the first message
    if (this.message1) {
      var firstLink = this.message1.querySelector('a');
      if (firstLink) {
        firstLink.appendChild(this.timerElement);
        this.timerElement.appendChild(this.clockElement);
      }
    }
    
    // Start the countdown
    this.updateTimer();
    
    var self = this;
    setInterval(function() {
      self.updateTimer();
    }, 1000);
    
    // Setup message switching if both messages exist
    if (this.hasAlternateMessages) {
      // Set initial state based on localStorage or default to message1
      this.setInitialMessageState();
      this.setupMessageSwitching();
    } else if (this.message1) {
      // If only one message, make sure it's visible
      this.message1.classList.add('active');
    }
  };
  
  SaleTimer.prototype.setInitialMessageState = function() {
    // Remove all active classes first to prevent flash
    if (this.message1) this.message1.classList.remove('active');
    if (this.message2) this.message2.classList.remove('active');
    
    try {
      // Check if we have a stored message state
      var activeMessage = localStorage.getItem('activePromoMessage');
      var lastSwitchTime = localStorage.getItem('promoMessageSwitchTime');
      var currentTime = new Date().getTime();
      
      // If we have a stored state and it's recent (within 7 seconds)
      if (activeMessage && lastSwitchTime && (currentTime - parseInt(lastSwitchTime, 10) < 7000)) {
        if (activeMessage === 'message2' && this.message2) {
          this.message2.classList.add('active');
        } else if (this.message1) {
          this.message1.classList.add('active');
        }
      } else {
        // Default to message1 or reset the cycle
        if (this.message1) this.message1.classList.add('active');
        localStorage.setItem('activePromoMessage', 'message1');
        localStorage.setItem('promoMessageSwitchTime', currentTime.toString());
      }
    } catch (e) {
      // In case localStorage is not available
      if (this.message1) this.message1.classList.add('active');
    }
  };
  
  SaleTimer.prototype.updateTimer = function() {
    var now = new Date();
    var endOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      23, 59, 59
    );
    
    var timeRemaining = endOfDay - now;
    
    if (timeRemaining <= 0) {
      // It's the end of the day, wait for the next update to reset
      return;
    }
    
    var hours = Math.floor(timeRemaining / (1000 * 60 * 60));
    var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);
    
    // Format the time as HH:MM:SS
    var formattedHours = hours < 10 ? '0' + hours : hours;
    var formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    var formattedSeconds = seconds < 10 ? '0' + seconds : seconds;
    
    // Update the clock element
    if (this.clockElement) {
      this.clockElement.textContent = formattedHours + ':' + formattedMinutes + ':' + formattedSeconds;
    }
  };
  
  SaleTimer.prototype.setupMessageSwitching = function() {
    var self = this;
    
    // Switch messages every 7 seconds
    setInterval(function() {
      try {
        var currentTime = new Date().getTime();
        
        if (self.message1.classList.contains('active')) {
          self.message1.classList.remove('active');
          self.message2.classList.add('active');
          localStorage.setItem('activePromoMessage', 'message2');
        } else {
          self.message2.classList.remove('active');
          self.message1.classList.add('active');
          localStorage.setItem('activePromoMessage', 'message1');
        }
        
        // Store the time we switched
        localStorage.setItem('promoMessageSwitchTime', currentTime.toString());
      } catch (e) {
        // If localStorage fails, just switch the messages
        if (self.message1.classList.contains('active')) {
          self.message1.classList.remove('active');
          self.message2.classList.add('active');
        } else {
          self.message2.classList.remove('active');
          self.message1.classList.add('active');
        }
      }
    }, 7000);
  };
  
  // Check scroll position and add/remove is-scrolled class
  function handleScroll() {
    if (window.scrollY > 0) {
      document.body.classList.add('is-scrolled');
    } else {
      document.body.classList.remove('is-scrolled');
    }
  }
  
  // Apply timer immediately if element exists, otherwise wait for DOM ready
  (function() {
    var container = document.querySelector('.promo-bar__content__shipping');
    
    // Setup scroll detection
    window.addEventListener('scroll', handleScroll);
    
    if (container) {
      new SaleTimer('.promo-bar__content__shipping');
    } else {
      // Fall back to DOM ready if element doesn't exist yet
      document.addEventListener('DOMContentLoaded', function() {
        new SaleTimer('.promo-bar__content__shipping');
      });
    }
  })(); 